import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  TextInput,
  Button,
  Layer,
  Form,
  Select,
  FormField,
} from "grommet";
import "./AddFlight.css";
import { useStore } from "../../../../../../Hooks/useStore";
import { observer } from "mobx-react";
import closeSidebar from "../../../../../../assets/close_small.svg";
import { Mixpanel } from "../../../../../../util/Helper";
import createFlightService from "../Users/CreateFlight/create-flight.service";
import { stringify } from "querystring";

const AddFlight = observer(({ onClose, initialFlightData }) => {
  const { rootStore } = useStore();
  const [newFlight, setNewFlight] = useState({
    ...initialFlightData,
    msn: "",
    tailNumber: "",
  });

  useEffect(() => {
    (async () => {
      let organizations = await createFlightService.getOrganizations();
      rootStore.adminStore.handleCreateFlightOrgList(organizations);

      let uInfo = localStorage.getItem("userinfo");
      const userinformation = JSON.parse(uInfo);

      let userOrg = await createFlightService.getOrgByUserName(userinformation.username);
      if (rootStore.adminStore.getRoleName.toLowerCase() == "admin") {
        rootStore.flightsStore.setSelectedOrd(userOrg.id);
      }

      // rootStore.adminStore.handleOrganization(orgResponse.id);

    })();
  }, []);
  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewFlight({ ...newFlight, [name]: value });
  };

  const handleOrganizationChange = (option) => {
    setNewFlight({ ...newFlight, organization: option });
  };

  const handleReset = () => {
    setNewFlight({
      registration: "",
      tailNumber: "",
      msn: "",
      fleetType: "",
      wifiProvider: "",
      organization: "",
    });
  };

  const onFormSubmit = ({ value }) => {
    let uInfo = localStorage.getItem("userinfo");
    const userinformation = JSON.parse(uInfo);
    Mixpanel.track("web_add_flight_submit_click", {
      name: userinformation.username,
    });
    // const { organization, tailNumber, msn, feettype, wifiProvider } = value;
    const { organization, tailNumber, msn, feettype, wifiProvider } = value;
    {/*
    const flight = JSON.parse(JSON.stringify(rootStore.flightsStore.getFleetType));

    // Check if `flight` is an object with both `value` and `label`
    let feettype;

    if (typeof flight === "object" && flight !== null && flight.value && flight.label) {
      // If the flight is an object with both value and label
      feettype = {
        id: flight.value,
        airCraftType: flight.label
      };
    } else if (typeof flight === "object" && flight.value == null) {
      // If flight is a plain string (e.g., "fgfgfg")
      feettype = {
        airCraftType: flight.label // Directly send the value as airCraftType
      };
    }
    console.log("rootStore.flightsStore.getWifiProvider", rootStore.flightsStore.getWifiProvider);

    const wifi = JSON.parse(JSON.stringify(rootStore.flightsStore.getWifiProvider));

    console.log("wifi", wifi);
    
    // Check if `wifi` is an object with both `value` and `label`
    let wifiProvider;

    if (typeof wifi === "object" && wifi !== null && wifi.value && wifi.label) {
      // If wifi is an object with both value and label
      wifiProvider = {
        id: wifi.value,
        wifiProvider: wifi.label
      };
    } else if (typeof wifi === "object" && wifi.value == null) {
      // If wifi is a plain string (e.g., "someWifiProvider")
      wifiProvider = {
        wifiProvider: wifi.label // Directly send the value as wifiProvider
      };
    }

    */}

    if (organization === "-1") {
      rootStore.notificationToastStore.showNotification("Please select organization.", true, 3000);
      return;
    }

    createFlightService.addFlight(organization, msn, feettype, wifiProvider, tailNumber) 
      .then(() => {
        rootStore.notificationToastStore.showNotification(
          "Flight added successfully",
          false,
          3000
        );
        rootStore.flightsStore.handleupdate();
        onClose();
      })
      .catch((e) => {
        rootStore.notificationToastStore.showNotification(
          "Failed to add flight: make sure the tail number is unique",
          true,
          3000
        );
      });
  };

  const [msnError, setMsnError] = useState("");

  const handleMsnChange = (e) => {
    let value = e.target.value;

    // Check if the value contains only digits
    if (/^[a-zA-Z]*$/.test(value)) {
      setMsnError("Numeric values only allowed."); // Display error for numeric input
    } else {
      setMsnError(""); // Clear error message for non-numeric input
    }

    // Update state with the current input value
    setNewFlight({ ...newFlight, msn: value });
  };

  const clearInputAndError = () => {
    setNewFlight({ ...newFlight, msn: "" }); // Clear input field
    setMsnError(""); // Clear error message
  };

  const handleTailNumberChange = (e) => {
    const value = e.target.value;
    // Allow alphanumeric input (both digits and letters)
    if (/^[a-zA-Z0-9]*$/.test(value)) {
      rootStore.adminStore.handleTailNumber(value);
      setNewFlight({ ...newFlight, tailNumber: value });
    }
  };

  let userInfo;
  useEffect(() => {
    (async () => {
      userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let roleLabel = JSON.parse(userInfo).roleLabel;
        rootStore.adminStore.handleRoleLabel(roleLabel);
        if (roleLabel.toLowerCase() == "admin") {
          let username = JSON.parse(userInfo).username;
          let userOrg = await createFlightService.getOrgByUserName(username);
          rootStore.flightsStore.handleAddOrg(userOrg.id);
        }
      }
    })();
  }, [userInfo]);

  // ||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||

  const flightOptions = rootStore.flightsStore.getFlightList.map(flight => ({
    value: flight.id,
    label: flight.airCraftType
  }));

  const [showOptions, setShowOptions] = useState(false);
  const [filterText, setFilterText] = useState('');
  const [selectedFleetType, setSelectedFleetType] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(flightOptions); // Initialize with all options


  const handleTextInputChange = (event) => {
    const value = event.target.value;
    rootStore.flightsStore.handleFleetType(value);
    setFilterText(value);
    setSelectedFleetType(value); // Update selectedFleetType with input text
    setShowOptions(true); // Show options as user types

    // Filter options based on input value
    const newFilteredOptions = flightOptions.filter(option =>
      option.label.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredOptions(newFilteredOptions); // Update filtered options
    const flightList = rootStore.flightsStore.getFlightList
    const selectedFlight = flightList.find((flight) => flight.airCraftType === value);

    // rootStore.flightsStore.handleFleetType({label:event.target.value,value:null});
    if (selectedFlight) {
      rootStore.flightsStore.handleFleetType({label:selectedFlight.airCraftType,value:selectedFlight.id});
    } else {
      rootStore.flightsStore.handleFleetType({ label: value, value: null })
    }
  };

  const handleOptionClick = (option) => {
    setSelectedFleetType(option.label); // Set selected fleet type
    setFilterText(option.label); // Set filter text to the selected option
    setShowOptions(false); // Hide the options
    rootStore.flightsStore.handleFleetType(option); // Update the store
  };


  const wifiProviderOptions = rootStore.flightsStore.getWifiProviderList.map(wifi => ({
    value:wifi.id,
    label: wifi.wifiProvider
  }))

  const [showWifiOptions, setShowWifiOptions] = useState(false);
  const [wifiFilterText, setWifiFilterText] = useState('');
  const [selectedWifiType, setSelectedWifiType] = useState("");
  const [filteredWifiOptions, setFilteredWifiOptions] = useState(wifiProviderOptions);

  const handleWifiTextInputChange = (event) => {
    const value = event.target.value;
    rootStore.flightsStore.handleWifiProvider(value);
    setWifiFilterText(value);
    setSelectedWifiType(value); // Update selectedFleetType with input text
    setShowWifiOptions(true); // Show options as user types
    // Filter options based on input value
    const newFilteredOptions = wifiProviderOptions.filter(option =>
      option.label.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredWifiOptions(newFilteredOptions); // Update filtered options
    // rootStore.flightsStore.handleWifiProvider({label:event.target.value, value:null});
    const wifiList = rootStore.flightsStore.getWifiProviderList
    const selectedWifi = wifiList.find((wifi) => wifi.wifiProvider === value);
    if (selectedWifi) {
      rootStore.flightsStore.handleWifiProvider({label:selectedWifi.wifiProvider,value:selectedWifi.id});
    } else {
      rootStore.flightsStore.handleWifiProvider({ label: value, value: null })
    }
  };

  const handleWifiOptionClick = (option) => {
    setSelectedWifiType(option.label); // Set selected fleet type
    setWifiFilterText(option.label); // Set filter text to the selected option
    setShowWifiOptions(false); // Hide the options
    rootStore.flightsStore.handleWifiProvider(option); // Update the store
  };


  // |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||

  // Handle outside click
  const aircraftRef = useRef(null);
    useEffect(() => {
    const handleAircraftClickOutside = (event) => {
      if (aircraftRef.current && !aircraftRef.current.contains(event.target)) {
        setShowOptions(false); // Close the dropdown
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleAircraftClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleAircraftClickOutside);
    };
  }, []);

  // Add this in your component
  const wifiDropdownRef = useRef(null);

  useEffect(() => {
    const handleWifiClickOutside = (event) => {
      if (wifiDropdownRef.current && !wifiDropdownRef.current.contains(event.target)) {
        setShowWifiOptions(false); // Close the dropdown
      }
    };

    // Add event listener for clicks
    document.addEventListener('mousedown', handleWifiClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleWifiClickOutside);
    };
  }, []);
  // End Handle outside click

  return (
    <Layer
      className="outer"
      full="vertical"
      position="right"
      onClickOutside={() => {
        rootStore.emsStore.handleAssignModal(false);
        rootStore.emsStore.handleSelectEmsId("");
        rootStore.emsStore.handleEmsListSearch("");
        onClose();
      }}
      onEsc={() => {
        rootStore.emsStore.handleAssignModal(false);
        rootStore.emsStore.handleSelectEmsId("");
        rootStore.emsStore.handleEmsListSearch("");
        onClose();
      }}
      style={{ borderRadius: "12px 0 0 12px", zIndex: 1000 }}
    >
      <div className="flight-header">
        <div className="title">Add Flights</div>
        <Button className="close-btn" onClick={onClose}>
          <img src={closeSidebar} style={{ width: 20, height: 20 }} />
          Close
        </Button>
      </div>
      <Form
        validate="change"
        onSubmit={onFormSubmit}
        className="create-user-form"
      >
        <FormField 
          label={rootStore.adminStore.getRoleName.toLowerCase() !== "admin"? "Tail Number" : "Registration"} 
          className="tailno-label flightlableborder" 
          name="tailNumber" 
          htmlFor="textinput-id" 
          // required
          validate={[
            (value) => (!value || value === "" ? "Tail Number is required" : undefined),
          ]}
        >
          <TextInput
            id="textinput-id"
            name="tailNumber"
            placeholder="Enter here"
            className="input-style"
            maxLength={100}
          />
        </FormField>

        <FormField label="MSN" name="msn" className="mb-0 flightlableborder" htmlFor="MSN">
          <TextInput
            id="MSN"
            name="msn"
            placeholder="Enter here"
            className="input-style"
            maxLength={100}
          />
        </FormField>

        <FormField 
          className="mb-0 flightlableborder" 
          label="Fleet Type" 
          name="feettype" 
          htmlFor="FEETTYPE" 
          // required
          validate={[
            (value) => (!value || value === "" ? "Fleet Type is required" : undefined),
          ]}
        >
          {/* <TextInput
            id="FEETTYPE"
            name="feettype"
            placeholder="Enter here"
            className="input-style"
          /> */}
          {/* <label className='label'>Aircraft Type</label> */}
            <TextInput
            id="FEETTYPE"
              className='input-style'
              placeholder="Enter here"
              maxLength={100}
              name="feettype"
              //value={selectedFleetType} // Controlled value based on state
              //onChange={handleTextInputChange} // Update the input value and filtered options
              //onFocus={() => setShowOptions(true)} // Show options on focus
            />
            {showOptions && filteredOptions.length > 0 && (
              {/*
              <ul style={{ listStyleType: 'none', margin: '0px',paddingLeft:'5px',marginLeft:"2px",fontSize:'15px' }} ref={aircraftRef}>
                {filteredOptions.map((item) => (
                  <li
                  style={{ textDecoration: 'none', paddingLeft: '5px',paddingTop:'10px',paddingBottom:'10px',margin:"0px", cursor: 'pointer',boxShadow: "0 0px 1px rgba(0, 0, 0, 0.1)"}}
                    key={item.value} // Use the value as the key
                    onClick={() => handleOptionClick(item)} // Handle option click
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
              */}
            )}
        </FormField>

        <FormField 
          className="mb-0 flightlableborder" 
          label="Wi-Fi Provider" 
          name="wifiProvider" 
          htmlFor="WIFIPROVIDER" 
          // required
          validate={[
            (value) => (!value || value === "" ? "Wi-Fi Provider is required" : undefined),
          ]}
        >
          {/* <TextInput
            id="WIFIPROVIDER"
            name="wifiProvider"
            placeholder="Enter here"
            className="input-style"
          /> */}
          <TextInput
              className='input-style'
              name="wifiProvider"
              placeholder="Enter here"
              maxLength={100}
              id="WIFIPROVIDER"
              //value={selectedWifiType} // Controlled value based on state
              //onChange={handleWifiTextInputChange} // Update the input value and filtered options
              //onFocus={() => setShowWifiOptions(true)} // Show options on focus
              
            />
            {showWifiOptions && filteredWifiOptions.length > 0 && (
              {/*
              <ul style={{ listStyleType: 'none', margin: '0px',paddingLeft:'5px',marginLeft:"2px",fontSize:'15px' }} ref={wifiDropdownRef}>
                {filteredWifiOptions.map((item) => (
                  <li
                  style={{ textDecoration: 'none', paddingLeft: '5px',paddingTop:'10px',paddingBottom:'10px',margin:"0px", cursor: 'pointer',boxShadow: "0 0px 1px rgba(0, 0, 0, 0.1)"}}
                    key={item.value} // Use the value as the key
                    onClick={() => handleWifiOptionClick(item)} // Handle option click
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
              */}
            )}
        </FormField>

        <div className={rootStore.adminStore.getRoleName.toLowerCase() == "admin" ? "organization-select " : "organization-select"}>
          <FormField
            label="Organization"
            name="organization"
            htmlFor="ORGANIZATION"
            placeholder="Please select organization"
            // required
            validate={[
              (value) => (!value || value === "" ? "Organization is required" : undefined),
            ]}
          >
            <Select
            name="organization"
            labelKey="label"
            valueKey={{ key: "value", reduce: true }}
            options={rootStore.adminStore.getCreateFlightOrgList
              .filter(org => 
                org.name.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .map(org => ({
                label: org.name,
                value: org.id,
              }))}
            value={rootStore.adminStore.getRoleName.toLowerCase() === "admin" 
              ? rootStore.flightsStore.getSelectedOrd 
              : undefined}
            disabled={rootStore.adminStore.getRoleName.toLowerCase() === "admin"}
            onSearch={setSearchQuery}
            searchPlaceholder="Search organizations..."
            // onChange={(e) => rootStore.flightsStore.setSelectedOrd(e.target.value)}
          />
          </FormField>
        </div>
        <div className="btn-outer">
          <Button
            className="reset"
            type="reset"
            label="Reset"
            onClick={() => {
              rootStore.flightsStore.handleFleetType("");
              setSelectedFleetType("");
              rootStore.flightsStore.handleWifiProvider("");
              setSelectedWifiType("");
            }}
            style={{
              flexDirection: "row",
              display: "flex",
              width: "120px",
              padding: "14px 49px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "10px",
              color: "#357EFF",
              backgroundColor: '#fff',
              border: '2px solid #357EFF',
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "24px",
            }}
          />
          <Button
            className="save"
            type="submit"
            label="Add"
            style={{
              display: "flex",
              width: "120px",
              marginLeft: "10px",
              padding: "14px 49px",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              borderRadius: "10px",
              background: "#357EFF",
              color: "#FFF",
              fontFamily: "Inter",
              fontSize: "16px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "24px",
            }}
          />
        </div>
      </Form>
    </Layer>
  );
});

export default AddFlight;
